module.exports = __webpack_public_path__ + "media/images/official/person02-09d4f498c8e6120833ca31e547d89c39.svg";